import { Component, Input, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from "../model/user";
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MustMatch } from '../_helpers/must-match.validator';
import { LocalVariable } from '../_helpers/localvariable'
import {ErrorStateMatcher} from '@angular/material/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	  const isSubmitted = form && form.submitted;
	  return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
   
	
  constructor(private http: HttpClient, private router: Router, private formBuilder: FormBuilder, private titleService: Title) {
	this.titleService.setTitle("Register - VirtualRacesFrance"); 
   }
  
  public submitted = false;
  public email;
  public password;
  public passwordConfirm;
  public hide = true;
  public loading = false;
  public captchaResponse;
  public error = false;
  public errorCapcha = false;
  public errorMessage;
  myRecaptcha: boolean
  private authUrl = environment.endpoint + '/users/add';


   registerForm = this.formBuilder.group({
		email: ['', [Validators.required,  Validators.email,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]] ,
		password: ['', [Validators.required, Validators.minLength(6)]],
		passwordConfirm: ['', Validators.required]
	}, {
		validator: MustMatch('password', 'passwordConfirm')
	});

  matcher = new MyErrorStateMatcher();


  resolved(captchaResponse: string) {
	this.captchaResponse = captchaResponse;
	this.errorCapcha = false;
  }
  

  ngOnInit(): void {
	
  }

  public get f() { return this.registerForm.controls; }

  register() {
		this.loading = true;
		this.submitted = true;
		
		if (this.registerForm.invalid) {
			if(this.captchaResponse === undefined){
				this.errorCapcha = true;
			}
			this.loading = false;
			return;
		}

		let user = new User(this.f.email.value, this.f.password.value, this.captchaResponse);

		this.http.post<any>(this.authUrl , user, { observe: 'response' }).subscribe(
			resp => {
				let data = {token : null};
				data.token = resp.headers.get('x-auth-header');
				LocalVariable.saveAuth(data, this.f.email.value);
				LocalVariable.checkLogIn(this.router);
			}, err => {
				if(err.status == 409){
					this.errorMessage = err.error;
				}else{
					this.errorMessage = "An error occured, please try again or contact support";
				}
				this.loading = false;
				this.error = true;
			}
		)
  }
	  
	  


}
